import { Stepper as MuiStepper, Step, StepLabel, Tooltip, createStyles, makeStyles } from '@material-ui/core';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import React from 'react';

export type StepStatus = 'unvisited' | 'incomplete' | 'complete';

export interface Step {
  title: string;
  content: JSX.Element;
  status?: StepStatus;
  invalidFields?: string[];
}

export interface Props {
  steps: Step[];
  currentStep: number;
  onChange: (step: number) => void;
}

const useStyles = makeStyles(() =>
  createStyles({
    stepper: {
      padding: '16px 32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    step: {
      cursor: 'pointer',
    },
    incompleteIcon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F57C00',
      color: 'white',
    },
  }),
);

const IncompleteStepIcon = ({ title }: { title?: string }) => {
  const classes = useStyles();
  return (
    <Tooltip title={title ?? ''}>
      <div className={classes.incompleteIcon}>
        <ReportProblemOutlinedIcon style={{ fontSize: 16, marginTop: -2 }} />
      </div>
    </Tooltip>
  );
};

export default function StepperHeader({ steps, currentStep, onChange }: Readonly<Props>) {
  const classes = useStyles();

  return (
    <MuiStepper connector={<></>} activeStep={currentStep} className={classes.stepper}>
      {steps.map((step: Step, index: number) => {
        const isComplete = step.status === 'complete';
        const isIncomplete = step.status === 'incomplete';

        return (
          <Step
            className={classes.step}
            key={step.title}
            onClick={() => onChange(index)}
            disabled={false}
            completed={isComplete}
          >
            <StepLabel
              {...(isIncomplete && {
                StepIconComponent: IncompleteStepIcon,
                StepIconProps: { title: step.invalidFields?.join(', ') },
              })}
            >
              {step.title}
            </StepLabel>
          </Step>
        );
      })}
    </MuiStepper>
  );
}
